/**
 * BrandLoader · v8.5.63 · piel — línea mono + barra de 2px, sin logo
 * pulsando ni ícono de spinner (antes: Zap con animate-pulse + Loader2 girando).
 */
export default function BrandLoader({ mensaje = "Cargando…" }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[var(--paper)]">
      <p className="font-mono text-[12px] uppercase tracking-[.08em] text-[var(--muted)]">{mensaje}</p>
      <div className="w-40 h-[6px] bg-[var(--line)] overflow-hidden rounded-full">
        <div className="h-full w-1/3 bg-[var(--ink)] animate-barLoad"/>
      </div>
    </div>
  );
}
